import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import "./index.css";
import { E_TICKET_API, GET_BOOKINGS_API } from "../../APIs";
import { FaAngleDown, FaAngleUp } from "react-icons/fa6";
import { getRowLengthAccordingToData } from "../../utils/func";
import { toast } from "react-toastify";
import CustomModal from "../../components/CustomModal";
import { CONFIRMBOOKING } from "../../constants/RoutingPath";
import { useNavigate } from "react-router-dom";


const customStyles = {
    headRow: {
        style: {
            backgroundColor: "#222539",
            color: "white",
            fontSize: "24px",
            fontWeight: "bold",
            padding: "10px",

        },
    },
    headCells: {
        style: {
            color: "#ffffff",
            fontSize: "26px",
            fontWeight: "bold",
            textAlign: "left",
            textTransform: "uppercase",
            padding: "10px",
            width: "150px"
        },
    },
    rows: {
        style: {
            backgroundColor: "#0f1018",
            fontSize: "20px ",
            color: "white",
            borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
        },
    },
    cells: {
        style: {
            color: "#ffffff",
            fontSize: "20px ",
            padding: "14px",
            textAlign: "left",
        },
    },
    pagination: {
        style: {
            backgroundColor: "#222539",
            color: "white",
            fontSize: "18px ",
            borderTop: "1px solid rgba(255, 255, 255, 0.1)",
        },
    },
};

const MyBookings = () => {
    const [bookingData, setBookingData] = useState([]);
    const [apiEnteriesLength, setApiEnteriesLength] = useState(0)
    const [filters, setFilters] = useState({
        event_name: "",
        bookingId: "",
        booking_date: "",
        trp_booking_status: "",
        page: 1,
        page_size: 10,
        sortBy: "latest",
        event_startdate: "",
        event_stopdate: "",
        supplier_booking_id: "",
        email: "",
        leaderName: "",
    });
    const [showFilters, setShowFilters] = useState(false);
    const [loader, setLoader] = useState(false)
    const navigate = useNavigate()

    useEffect(() => {
        fetchAllBookings();
    }, [filters?.page, filters?.page_size]);


    const handlePageChange = (page) => {
        setFilters({ ...filters, page: page })
    };

    const handleRowsPerPageChange = async (newRowsPerPage) => {
        setFilters({ ...filters, page: 1, page_size: newRowsPerPage })
    };


    const fetchAllBookings = async (filter_option) => {
        try {
            setLoader(true)
            const response = await GET_BOOKINGS_API(filter_option ? filter_option : filters);
            if (response?.status && Array.isArray(response?.data?.data)) {
                setBookingData(response?.data?.data);
                setApiEnteriesLength(response?.data?.total || 0)
            } else {
                setBookingData([]);
            }
        } catch (error) {
            console.error("Error fetching bookings:", error);
            setBookingData([]);
        } finally {
            setLoader(false)
        }
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters((prevFilters) => ({
            ...prevFilters,
            [name]: value,
        }));
    };

    const handleResetFilter = () => {
        const filters = {
            event_name: "",
            bookingId: "",
            booking_date: "",
            trp_booking_status: "",
            page: 1,
            page_size: 10,
            sortBy: "latest",
            event_startdate: "",
            event_stopdate: "",
            email: "",
            leaderName: "",
        }
        setFilters(filters)
        fetchAllBookings(filters)
    }

    const navigateToBookingDetailPage = (id) => {
        navigate(`${CONFIRMBOOKING}/${id}`)
    }

    const columns = [
        {
            name: "Booking ID",
            selector: (row) => `TRP ${row.id}`,
            cell: (row) => <span onClick={() => navigateToBookingDetailPage(row.id)} style={{ fontSize: "16px", color: "rgb(59 200 229)", cursor: "pointer" }}>{`TRP${row.id}`}</span>
        },
        { name: "Supplier Booking Id", selector: (row) => row.supplier_booking_id ? row.supplier_booking_id : "N/A", width: "180px", },
        {
            name: "Booking Status", selector: row => row?.trp_booking_status ? `${row?.trp_booking_status}` : "N/A",
            cell: (row) => <span style={{ fontSize: "14px", textTransform: "capitalize", cursor: "pointer" }}>{row?.trp_booking_status ? `${row?.trp_booking_status}` : "N/A"}</span>,
            width: "130px"
        },
        { name: "Supplier", selector: row => row?.trp_supplier_name ? `${row?.trp_supplier_name}` : "N/A", width: "130px" },
        { name: "Booking Date", selector: row => row?.created ? `${row?.created_ist}` : "N/A", width: "150px" },
        { name: "Email", selector: row => row?.booking_email ? `${row?.booking_email}` : "N/A", width: "180px" },
        {
            name: "Leader Name",
            selector: (row) => {
                const leadGuest = row?.booking_guest?.find((item) => item.lead_guest);
                return leadGuest ? `${leadGuest.first_name} ${leadGuest.last_name}` : "";
            },
            width: "180px"
        },
        { name: "Event Name", selector: (row) => row?.booking_ticket?.[0]?.event_name ? `${row?.booking_ticket?.[0]?.event_name}  ` : "N/A", width: "180px" },
        { name: "Venue Name", selector: (row) => row?.booking_ticket?.[0]?.venue_name ? `${row?.booking_ticket?.[0]?.venue_name}` : "N/A", width: "180px" },
        { name: "Visting Name", selector: (row) => row?.booking_ticket?.[0]?.visiting_name ? `${row?.booking_ticket?.[0]?.visiting_name}` : "N/A", width: "180px" },
        { name: "Tournament Name", selector: (row) => row?.booking_ticket?.[0]?.tournament_name ? `${row?.booking_ticket?.[0]?.tournament_name} ` : "N/A", width: "180px" },
        // { name: "Supplier Markup", selector: (row) => row?.supplierMarkup?.[row?.agent_id] ? `${row?.supplierMarkup?.[row?.agent_id]}` : "N/A", width: "120px" },
        // { name: "Guest Status", selector: row => `${row?.guestdata_status}` || "N/A" },
        { name: "Amount", selector: (row) => row.total_netrate_inr ? row.total_netrate_inr : "N/A", width: "120px" },
        // { name: "Distributor Status", selector: (row) => row.distributorfinancial_status ? row.distributorfinancial_status : "N/A" },
        // { name: "Logistic Status", selector: (row) => row.logistic_status ? row.logistic_status : "N/A" },
        // { name: "Booking Code", selector: row => row?.booking_code ? `${row?.booking_code}` : "N/A" },

    ]

    return (
        <>
            <div className="Events_booking_page">
                <div className="events_container">
                    <div className="my-booking">
                        <div className="booking_container">
                            <div className="booking_header">
                                <h2 className="booking-title">Bookings</h2>
                                <div className="filter_option" >
                                    <p onClick={handleResetFilter} disabled={loader} >Reset filter</p>
                                    <button className="filter-toggle-btn" onClick={() => setShowFilters(!showFilters)}>
                                        {showFilters ? "Close Filters" : "Open Filters"}
                                        {showFilters ? <FaAngleUp size="15" /> : <FaAngleDown size="15" />}
                                    </button>
                                </div>
                            </div>
                            <div className={`filter-container ${showFilters ? "show" : ""}`}>
                                <div className="booking_filters" >
                                    <div className="filters_input" >
                                        <label className="filterLabel" >Event Name</label>
                                        <input
                                            type="text"
                                            name="event_name"
                                            placeholder="Search by Event Name"
                                            value={filters.event_name}
                                            onChange={handleFilterChange}
                                        />
                                    </div>
                                    <div className="filters_input" >
                                        <label className="filterLabel" >Booking ID</label>
                                        <input
                                            type="text"
                                            name="bookingId"
                                            placeholder="Search by Booking ID"
                                            value={filters.bookingId}
                                            onChange={handleFilterChange}
                                        />
                                    </div>
                                    <div className="filters_input" >
                                        <label className="filterLabel" >Supplier Booking ID</label>
                                        <input
                                            type="text"
                                            name="supplier_booking_id"
                                            placeholder="Search by Supplier Booking ID"
                                            value={filters.supplier_booking_id}
                                            onChange={handleFilterChange}
                                        />
                                    </div>
                                    <div className="filters_input" >
                                        <label className="filterLabel" >Email</label>
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="Search by email"
                                            value={filters.email}
                                            onChange={handleFilterChange}
                                        />
                                    </div>
                                    <div className="filters_input" >
                                        <label className="filterLabel" >Booking Date</label>
                                        <input
                                            type="date"
                                            name="booking_date"
                                            value={filters.booking_date}
                                            onChange={handleFilterChange}
                                        />
                                    </div>
                                    <div className="filters_input" >
                                        <label className="filterLabel" >Booking Status</label>
                                        <select name="trp_booking_status" value={filters.trp_booking_status} onChange={handleFilterChange}>
                                            <option value="">Select Status</option>
                                            <option value="1">Vouchered</option>
                                            <option value="2">Pending</option>
                                            {/* <option value="3">Postponed</option>
                                        <option value="4">Cancelled</option>
                                        <option value="0">Failed</option> */}
                                        </select>
                                    </div>
                                    <div className="filters_input" >
                                        <label className="filterLabel" >Leader Name</label>
                                        <input
                                            type="text"
                                            name="leaderName"
                                            placeholder="Search by leader name"
                                            value={filters.leaderName}
                                            onChange={handleFilterChange}
                                        />
                                    </div>
                                    <div className="filters_input">
                                        <label className="filterLabel" >Event Date</label>
                                        <div className="dual_inputs" >
                                            <input
                                                type="date"
                                                name="event_startdate"
                                                placeholder="Start date"
                                                value={filters.event_startdate}
                                                onChange={handleFilterChange}
                                            />
                                            <input
                                                type="date"
                                                name="event_stopdate"
                                                value={filters.event_stopdate}
                                                onChange={handleFilterChange}
                                            />
                                        </div>
                                    </div>

                                </div>
                                <div className="filter_search_btn" >
                                    <button className="search-btn" disabled={loader} onClick={() => fetchAllBookings()}>
                                        Search
                                    </button>
                                </div>
                            </div>
                            <DataTable
                                columns={columns}
                                data={bookingData}
                                pagination
                                paginationServer
                                customStyles={customStyles}
                                progressPending={loader}
                                paginationTotalRows={apiEnteriesLength}
                                paginationRowsPerPageOptions={getRowLengthAccordingToData(
                                    apiEnteriesLength
                                )}
                                onChangePage={handlePageChange}
                                paginationPerPage={filters?.page_size}
                                onChangeRowsPerPage={handleRowsPerPageChange}
                                theme="dark"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MyBookings;
